import { createAppHistory } from './createAppHistory'


export const appHistory = createAppHistory()